import { useListingCTAs } from '../../../hooks/useListingCTAs';
import { Button } from '../../ui/Button';

export const SpokeFooterCTAs = () => {
  const { ctas, overlays } = useListingCTAs();

  if (ctas.length === 0) return null;

  return (
    <>
      {ctas.toReversed().map((cta) => (
        <Button
          key={cta.id}
          shape="rectangle"
          tone="brand"
          emphasis={cta.emphasis}
          fluid
          onClick={cta.onClick}
          aria-label={cta.ariaLabel}
        >
          {cta.label}
        </Button>
      ))}
      {overlays}
    </>
  );
};
